<template>
  <div class="d-flex align-center column-gap-1 cursor-pointer" @click.stop="toggleSort(column)">
    <span class="heading-xs-bold">{{ column.title }}</span>
    <slot></slot>
    <app-material-icon
      v-if="isCurrentSort"
      :name="isAscending ? 'arrow_downward' : 'arrow_upward'"
      size="sm"
    />
    <app-material-icon
      v-else
      name="mobiledata_arrows"
      color="icon-secondary"
      size="sm"
    />
  </div>
</template>

<script>
export default {
  name: 'DataTableSortHeader',
  props: {
    column: {
      type: Object,
      required: true,
    },
    sortKey: {
      type: String,
      required: true,
    },
    currentSort: {
      type: Array,
      required: true,
    },
  },
  emits: ['toggle-sort'],
  computed: {
    isCurrentSort () {
      return this.currentSort[0]?.key === this.sortKey
    },
    isAscending () {
      return this.currentSort[0]?.order === 'asc'
    },
  },
  methods: {
    toggleSort (column) {
      this.$emit('toggle-sort', column)
    },
  },
}
</script>
